<template>
  <div>
    <b-table
      sticky-header
      responsive
      show-empty
      hover
      fixed
      :busy="loading"
      :items="registros ? registros.data : null"
      :fields="fields"
      @row-dblclicked="ver"
    >
      <template #cell(modification_type_text)="data">
        <AlertTypeModification
          :modification_type="data.item.modification_type"
          :msgToolTips="data.item.modification_type_text"
          :modification_type_text="data.item.new_record.scenario.name"
        />
      </template>
      <template #cell(fecha)="data">
        <VerRegistro
          :row="data"
          :opcionVer="opcionVer"
          @ver="$emit('ver', data.item)"
        >
          <alert-sin-asignar
            :icon="true"
            variant="danger"
            text="Sin asignar"
            v-if="!data.value.name"
          ></alert-sin-asignar>
          {{ data.value.name }}
        </VerRegistro>
      </template>
      <template #table-busy>
        <div class="text-center my-2 mb-3">
          <OverlayButton clase="overlay-md"></OverlayButton>
        </div>
      </template>
    </b-table>

    <Pagination
      :data="registros"
      :limit="limit"
      @pagination-change-page="eventoPaginar"
      align="center"
    >
      <template #prev-nav>
        <span>&lt;</span>
      </template>
      <template #next-nav>
        <span>&gt;</span>
      </template>
    </Pagination>
  </div>
</template>

<script>
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import Pagination from "laravel-vue-pagination";
import VerRegistro from "@/components/datatables/VerRegistro.vue";
import AlertSinAsignar from "@/components/core/alert/alert-sin-asignar.vue";
import AlertTypeModification from "@/components/core/datatable/alert-type-modification.vue";
export default {
  name: "tipspointsale-table-history",
  components: {
    OverlayButton,
    Pagination,
    VerRegistro,
    AlertSinAsignar,
    AlertTypeModification,
  },
  emits: ["paginar", "ver"],
  data() {
    return {
      limit: 10,
      fields: [
        {
          label: "Usuario",
          key: "user",
          formatter: "name_user",
          sortable: true,
        },
        {
          label: "Tipo de modificación",
          key: "modification_type_text",
          sortable: true,
        },
        {
          label: "Sección de Origen",
          key: "origin_text",
          sortable: true,
        },
        {
          label: "Fecha y hora",
          key: "created_at",
          formatter: "fechaHora",
          sortable: true,
        },
      ],
    };
  },
  props: {
    registros: {
      type: Object,
      default() {
        return { data: null, meta: null, links: null };
      },
    },
    opcionVer: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ver(item /*index, event*/) {
      this.$emit("ver", item);
    },
    eventoPaginar(page = 1) {
      this.$emit("paginar", page);
    },
    name_user(value) {
      return "CC " + value.cc + " - " + value.name;
    },
    fechaHora(value) {
      return this.$moment(value).format("YYYY-MM-DD hh:mm a");
    },
  },
};
</script>

<style></style>
